import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {InsoleMaterialModel} from "../../../api/entity/insoleMaterial.model";

@Injectable()
export class InsoleMaterialRepository extends AbstractRepositoryV2<InsoleMaterialModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsoleMaterial', serviceElementsFactory, injector);
    }
}
